module.exports = __webpack_public_path__ + "media/icons-for-sprite/icon-zoom--white-c559e47b.svg";